import { render, staticRenderFns } from "./BillTemplate.vue?vue&type=template&id=cc2149ea&"
import script from "./BillTemplate.vue?vue&type=script&lang=js&"
export * from "./BillTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BillTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports